import cn from 'classnames'
import BaseModal, {
  BaseModalProps,
} from 'ext-ui/components/BaseModal/BaseModal'
import React, { ReactElement } from 'react'
import ReviewEnrollCard, {
  ReviewEnrollCardProps,
} from 'src/app/ReviewEnrollCard/ReviewEnrollCard'
import { useTranslate } from 'src/localization/Trns'

import style from './ConnectPhysicalCardModal.style'

type ConnectPhysicalCardModalProps = BaseModalProps & {
  reviewEnrollCardProps: ReviewEnrollCardProps
}

export default function ConnectPhysicalCardModal(
  props: ConnectPhysicalCardModalProps,
): ReactElement {
  const translate = useTranslate()
  const {
    className = '',
    variant = 'popup',
    isOpen,
    onClose,
    reviewEnrollCardProps,
  } = props

  return (
    <BaseModal
      className={cn('ConnectPhysicalCardModal', className)}
      variant={variant}
      isOpen={isOpen}
      onClose={onClose}
      css={style}
      aria-label={translate('Connect Physical Card Modal')}
    >
      <ReviewEnrollCard {...reviewEnrollCardProps} />
    </BaseModal>
  )
}
